import { Currency } from './currency';

export class Country {

    id: number|undefined;
    active:boolean;
    code: string;
    shortLabel:string;
    longLabel:string;
    currency:Currency;
  
  }
  